import './IconButton.less';
import Icon from '../icon/Icon';
import { IconId } from '../icon/icons';

export type IconButtonProps = {
    size?: 'x-small' | 'small' | 'medium' | 'large' | 'x-large';
    iconSize?: 'x-small' | 'small' | 'medium' | 'large' | 'x-large';
    iconId: IconId;
    onClick?: (event: MouseEvent) => void;
    variant: 'default' | 'light' | 'primary' | 'magic' | 'glass';
    className?: string;
    disabled?: boolean;
    badge?: string;
    title?: string;
    raised?: boolean;
    active?: boolean;
    href?: string;
};

const IconButton = ({
    onClick,
    size = 'small',
    iconSize = size,
    variant,
    iconId,
    className = '',
    disabled,
    badge,
    title,
    raised = false,
    active = false,
    href
}: IconButtonProps) => {
    const commonProps = {
        title,
        className: `bri-IconButton bri-IconButton-size-${size} bri-IconButton-variant-${variant} ${
            badge ? 'bri-IconButton-with-badge' : ''
        } ${raised ? 'bri-IconButton-raised' : ''} ${
            active ? 'bri-active' : ''
        } ${className}`,
        'data-bri-badge': badge ?? '',
        onClick
    };

    const icon = (
        <Icon
            color={variant === 'magic' ? 'gradient-primary' : undefined}
            iconId={iconId}
            size={iconSize}
        />
    );

    return href ? (
        <a
            {...commonProps}
            target="_blank"
            href={href}
            tabIndex={disabled ? -1 : undefined}
            aria-disabled={disabled}
            onClick={disabled ? e => e.preventDefault() : onClick}
        >
            {icon}
        </a>
    ) : (
        <button type="button" disabled={disabled} {...commonProps}>
            {icon}
        </button>
    );
};

export default IconButton;
